module.exports = function (isMobile) {
  return {
    // default fake data
    defaultPowerOptions: [{
      productId: '6757458116681',
      variantId: [],
      tag: 'Recommended',
      productName: '10Kwh Power Kits',
      name: 'Get Set Kit (10kWh) ',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '£',
      includes: ['10Kwh LFP Battery x 1', 'Power Hub', 'Pacchetto cavi'],
      details: {},
      img: '/img/calculators/mm100/power-2kw.jpg',
      imgH5: '/img/calculators/mm100H5/power-2kw.jpg'
    }, {
      productId: '6757463720009',
      variantId: [],
      tag: 'Delux',
      productName: '15Kwh Power Kits',
      name: 'Get Set Kit (15kWh) ',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '£',
      includes: ['1Batteria LFP da 5kWh x 1', 'Power Hub', 'Pacchetto cavi'],
      details: {},
      img: '/img/calculators/mm100/power-2kw.jpg',
      imgH5: '/img/calculators/mm100H5/power-2kw.jpg'
    }, {
      productId: '6757464277065',
      variantId: [],
      tag: 'Regular',
      usage: 'Daily usage',
      productName: '15Kwh Power Kits',
      name: 'Get Set Kit (15kWh) ',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '£',
      includes: ['10Kwh LFP Battery x 1', 'Power Hub', 'Pacchetto cavi'],
      details: {},
      img: '/img/calculators/mm100/power-2kw.jpg',
      imgH5: '/img/calculators/mm100H5/power-2kw.jpg'
    }],
    defaultComboOptions: [{
      id: 11,
      name: 'Ultimate Combo1',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '€',
      subs: [{
        id: 110,
        name: 'Distribution Panel',
        desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
        img: '/img/calculators/mm100/step4-panel.png',
        details: {}
      }]
    }, {
      id: 12,
      name: 'Ultimate Combo2',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '€',
      subs: [{
        id: 123,
        name: 'Distribution Panel',
        desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
        img: '/img/calculators/mm100/step4-panel.png',
        details: {}
      }, {
        id: 124,
        name: 'Distribution Panel',
        desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
        img: '/img/calculators/mm100/step4-panel.png',
        details: {}
      }, {
        id: 126,
        name: 'Distribution Panel',
        desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
        img: '/img/calculators/mm100/step4-panel.png',
        details: {}
      }]
    }],
    defaultSolarOptions: [{
      id: 111,
      name: '100W Firled Grid',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '€',
      desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      time: '1.4 Hrs',
      img: '/img/calculators/mm100/step4-panel.png',
      details: {},
      question: {}
    }, {
      id: 112,
      name: '400W Firled Grid',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '€',
      desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      time: '1.4 Hrs',
      img: '/img/calculators/mm100/step4-panel.png',
      details: {},
      question: {}
    }, {
      id: 113,
      name: '150W Firled Grid',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '€',
      desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      time: '1.4 Hrs',
      img: '/img/calculators/mm100/step4-panel.png',
      details: {},
      question: {}
    }],
    // real data
    // power kit
    powerPack: {
      2: {
        productId: '7763555057905',
        variantId: ['43104481247473', '43104481280241', '43104481313009'],
        capacity: 2,
        productName: '2kWh Power Kits',
        name: 'Get Set Kit (2kWh) ',
        discountPrice: 3898,
        originalPrice: 4898,
        unit: '€',
        includes: ['Batteria LFP da 2kWh x 1', 'Power Hub', 'Pacchetto cavi'],
        img: '/img/calculators/mm100/power-2kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-2kw.jpg',
        detailImg: '/img/calculators/mm100/power-2kw-detail.jpg'
      },
      4: {
        productId: '7763555221745',
        variantId: ['43104482459889', '43104482492657', '43104482525425'],
        capacity: 4,
        productName: '4kWh Power Kits',
        name: 'Get Set Kit (4kWh) ',
        discountPrice: 5597,
        originalPrice: 7097,
        unit: '€',
        includes: ['Batteria LFP da 2kWh x 2', 'Power Hub', 'Pacchetto cavi'],
        img: '/img/calculators/mm100/power-4kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-4kw.jpg',
        detailImg: '/img/calculators/mm100/power-4kw-detail.jpg'
      },
      5: {
        productId: '7763555385585',
        variantId: ['43104483508465', '43104483541233', '43104483574001'],
        capacity: 5,
        productName: '5kWh Power Kits',
        name: 'Get Set Kit (5kWh) ',
        discountPrice: 5998,
        originalPrice: 7498,
        unit: '€',
        includes: ['Batteria LFP da 5kWh x 1', 'Power Hub', 'Pacchetto cavi'],
        img: '/img/calculators/mm100/power-5kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-5kw.jpg',
        detailImg: '/img/calculators/mm100/power-5kw-detail.jpg'
      },
      10: {
        productId: '7763555549425',
        variantId: ['43104483770609', '43104483803377', '43104483836145'],
        capacity: 10,
        productName: '10kWh Power Kits',
        name: 'Get Set Kit (10kWh) ',
        discountPrice: 9797,
        originalPrice: 12297,
        unit: '€',
        includes: ['Batteria LFP da 5kWh x 2', 'Power Hub', 'Pacchetto cavi'],
        img: '/img/calculators/mm100/power-10kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-10kw.jpg',
        detailImg: '/img/calculators/mm100/power-10kw-detail.jpg'
      },
      15: {
        productId: '7763555713265',
        variantId: ['43104484098289', '43104484131057', '43104484163825'],
        capacity: 15,
        productName: '15kWh Power Kits',
        name: 'Get Set Kit (15kWh) ',
        discountPrice: 13596,
        originalPrice: 17096,
        unit: '€',
        includes: ['Batteria LFP da 5kWh x 3', 'Power Hub', 'Pacchetto cavi'],
        img: '/img/calculators/mm100/power-15kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-15kw.jpg',
        detailImg: '/img/calculators/mm100/power-15kw-detail.jpg'
      }
    },
    // combo
    comboPack: [{
      productId: 1,
      variantId: '',
      name: "Controlla e tieni d'occhio il consumo energetico.",
      discountPrice: 500,
      originalPrice: 570,
      unit: '€',
      subs: [{
        comboSubId: 'combo_1_sub_1',
        name: 'Pannello di distribuzione intelligente CA/CC',
        desc: "Con 12 posizioni CC con fusibile e 6 posizioni CA con protezione AFCI è possibile gestire la distribuzione dell'alimentazione intorno al proprio camper o a una piccola casa. Controlla fino a 6 posizioni CC dall'App EcoFlow o dalla console.",
        img: '/img/calculators/mm100/combo-distribution.jpg',
        imgH5: '/img/calculators/mm100H5/combo-distribution.jpg',
        details: {
          title: 'Pannello di distribuzione intelligente CA/CC',
          desc: "Con 12 posizioni CC con fusibile e 6 posizioni CA con protezione AFCI è possibile gestire la distribuzione dell'alimentazione intorno al proprio camper o a una piccola casa. Controlla fino a 6 posizioni CC dall'App EcoFlow o dalla console.",
          img: '/img/calculators/mm100/combo-detail-distribution.jpg',
          imgH5: '/img/calculators/mm100H5/combo-distribution.jpg',
          specParams: [{
            key: 'Ingresso principale CA',
            value: '16A Max, 230V, 3600W'
          }, {
            key: 'Ingresso principale CC',
            value: '70A Max'
          }, {
            key: 'Uscita CA',
            value: '6 posizioni CA, Max 10A ognuna'
          }, {
            key: 'Uscita CC',
            value: '12 posizioni CC con fusibile (6 posizioni regolabili tramite console e app del Power Kit) '
          }, {
            key: 'Temperatura di esercizio',
            value: 'da -25 °C a 60 °C'
          }, {
            key: 'Dimensioni',
            value: '210 × 354 × 98 mm (Altezza × Larghezza × Profondità)'
          }, {
            key: 'Peso netto',
            value: '2,6 kg'
          }, {
            key: 'Livello di protezione',
            value: 'IP21'
          }, {
            key: 'Test e certificazione',
            value: 'CE, UL, FCC, EMC Classe B'
          }]
        }
      }, {
        comboSubId: 'combo_1_sub_2',
        name: 'Staffa di montaggio',
        desc: 'Monta le tue batterie in modo sicuro e stabile.',
        img: '/img/calculators/mm100/combo-strap.jpg',
        imgH5: '/img/calculators/mm100H5/combo-strap.jpg'
      }]
    }, {
      productId: 2,
      variantId: '',
      name: 'Aggiungi potenza, controlla il sistema e monitora il consumo energetico.',
      discountPrice: 800,
      originalPrice: 900,
      unit: '€',
      subs: [{
        comboSubId: 'combo_2_sub_1',
        name: 'Pannello di distribuzione intelligente CA/CC',
        desc: "Con 12 posizioni CC con fusibile e 6 posizioni CA con protezione AFCI è possibile gestire la distribuzione dell'alimentazione intorno al proprio camper o a una piccola casa. Controlla fino a 6 posizioni CC dall'App EcoFlow o dalla console.",
        img: '/img/calculators/mm100/combo-distribution.jpg',
        imgH5: '/img/calculators/mm100H5/combo-distribution.jpg',
        details: {
          title: 'Pannello di distribuzione intelligente CA/CC',
          desc: "Con 12 posizioni CC con fusibile e 6 posizioni CA con protezione AFCI è possibile gestire la distribuzione dell'alimentazione intorno al proprio camper o a una piccola casa. Controlla fino a 6 posizioni CC dall'App EcoFlow o dalla console.",
          img: '/img/calculators/mm100/combo-detail-distribution.jpg',
          imgH5: '/img/calculators/mm100H5/combo-distribution.jpg',
          specParams: [{
            key: 'Ingresso principale CA',
            value: '30A Max, 120V, 3600W'
          }, {
            key: 'Ingresso principale CC',
            value: '70A Max'
          }, {
            key: 'Uscita CA',
            value: '6 posizioni CA, Max 10A ognuna'
          }, {
            key: 'Uscita CC',
            value: '12 posizioni CC con fusibile (6 posizioni regolabili tramite console e app del Power Kit) '
          }, {
            key: 'Temperatura di esercizio',
            value: 'da -25 °C a 60 °C'
          }, {
            key: 'Dimensioni',
            value: '210 × 354 × 98 mm (Altezza × Larghezza × Profondità)'
          }, {
            key: 'Peso netto',
            value: '2,6 kg'
          }, {
            key: 'Livello di protezione',
            value: 'IP21'
          }, {
            key: 'Test e certificazione',
            value: 'CE, UL, FCC, EMC Class B'
          }]
        }
      }, {
        comboSubId: 'combo_2_sub_2',
        name: 'Console di Power Kits EcoFlow',
        desc: 'Controlla, monitora e visualizza il tuo consumo energetico.',
        img: '/img/calculators/mm100/combo-console.jpg',
        imgH5: '/img/calculators/mm100H5/combo-console.jpg',
        details: {
          title: 'Console di Power Kits EcoFlow',
          desc: 'Controlla, monitora e visualizza il tuo consumo energetico.',
          img: '/img/calculators/mm100/combo-detail-console.jpg',
          imgH5: '/img/calculators/mm100H5/combo-console.jpg',
          specParams: [{
            key: 'Touch screen (diagonale): ',
            value: '7 pollici (154,21 x 85,92 mm) (Larghezza × Altezza)'
          }, {
            key: 'Tensione di alimentazione',
            value: '12 VDC'
          }, {
            key: 'Temperatura di esercizio',
            value: '-25°C-60°C'
          }, {
            key: 'Dimensioni',
            value: '113,3 × 204,5 × 22,35 mm (Altezza × Larghezza × Profondità)'
          }, {
            key: 'Peso netto',
            value: '450 g'
          }, {
            key: 'Testing and Certification',
            value: 'CE, UL, FCC, EMC Classe B'
          }]
        }
      }, {
        comboSubId: 'combo_2_sub_3',
        name: 'Smart Generator',
        desc: "In casi estremi puoi usare il tuo Smart Generator come alimentazione d'emergenza. È fino al 25% più efficiente rispetto ad altri generatori, consentendoti di risparmiare carburante e tempo, ed evitare l'emissione di fumi.",
        img: '/img/calculators/mm100/combo-generator.jpg',
        imgH5: '/img/calculators/mm100H5/combo-generator.jpg',
        details: {
          title: 'Smart Generator',
          desc: "In casi estremi puoi usare il tuo Smart Generator come alimentazione d'emergenza. È fino al 25% più efficiente rispetto ad altri generatori, consentendoti di risparmiare carburante e tempo, ed evitare l'emissione di fumi.",
          img: '/img/calculators/mm100/combo-detail-generator.jpg',
          imgH5: '/img/calculators/mm100H5/combo-generator.jpg',
          specParams: [{
            key: 'Peso netto (kg)',
            value: '29,3 kg'
          }, {
            key: 'Dimensioni (cm)',
            value: '59,7 x 29,6 x 47,5 cm'
          }, {
            key: 'Tensione nominale',
            value: '230V'
          }, {
            key: 'Tipo',
            value: 'Generatore inverter'
          }, {
            key: 'Frequenza',
            value: '50Hz'
          }, {
            key: 'Potenza di uscita nominale',
            value: '1800 W (picco 1900 W)'
          }, {
            key: 'Tipo di carburante',
            value: 'Carburante senza piombo'
          }, {
            key: 'Volume del serbatoio carburante',
            value: '4 L / 1,06 gal'
          }, {
            key: 'Tempo di funzionamento continuo',
            value: '3,5 ore (a pieno carico)'
          }]
        }
      }, {
        comboSubId: 'combo_2_sub_4',
        name: 'Staffa di montaggio',
        desc: 'Monta le tue batterie in modo sicuro e stabile.',
        img: '/img/calculators/mm100/combo-strap.jpg',
        imgH5: '/img/calculators/mm100H5/combo-strap.jpg'
      }]
    }],
    // solar panel
    solarPack: [{
      productId: '7795661504753',
      variantId: '43234286829809',
      name: '2 x Pannello solare rigido da 100 W + 2 x Piedini di montaggio solari rigidi ',
      discountPrice: 179,
      originalPrice: 229,
      // discountRate: 0.8,
      unit: '€',
      number: 0,
      capacity: 200,
      img: '/img/calculators/mm100/solar-100-rigid.jpg',
      imgH5: '/img/calculators/mm100H5/solar-100-rigid.jpg',
      // desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      details: {
        title: '2 x Pannello solare rigido da 100 W + 2 x Piedini di montaggio solari rigidi ',
        desc: '',
        img: '/img/calculators/mm100/solar-detail-100-rigid.jpg',
        imgH5: '/img/calculators/mm100H5/solar-100-rigid.jpg',
        specParams: [{
          key: 'Potenza nominale',
          value: '100W (+/-5W)'
        }, {
          key: 'Tensione a circuito aperto',
          value: '20,3V'
        }, {
          key: 'Corrente di cortocircuito',
          value: '6,3A'
        }, {
          key: 'Tensione di esercizio massima',
          value: '17,1V'
        }, {
          key: 'Corrente di esercizio massima',
          value: '5,9A'
        }, {
          key: 'Coefficiente di temperatura della potenza nominale',
          value: '-0,39%/°C'
        }, {
          key: 'Coefficiente di temperatura della tensione a circuito aperto',
          value: '-0,33%/°C'
        }, {
          key: 'Coefficiente di temperatura della corrente di cortocircuito',
          value: '0,06%/°C'
        }, {
          key: 'Tensione massima del sistema',
          value: '600 V CC (UL)'
        }, {
          key: 'Corrente massima del fusibile',
          value: '15A'
        }, {
          key: 'Peso del pannello solare',
          value: 'circa 6,2 kg (13,7 lb)'
        }, {
          key: 'Dimensioni',
          value: '98 x 58,6 x 3 cm'
        }]
      },
      question: {}
    }, {
      productId: '7843558523121',
      variantId: '43419242135793',
      name: '2 x Pannello solare rigido da 100 W + 4 x Piedini di montaggio solari rigidi ',
      discountPrice: 599,
      originalPrice: 799,
      // discountRate: 0.8,
      unit: '€',
      number: 0,
      capacity: 800,
      freeShip: 1,
      img: '/img/calculators/mm100/solar-400-rigid.jpg',
      imgH5: '/img/calculators/mm100H5/solar-400-rigid.jpg',
      // desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      details: {
        title: '2 x Pannello solare rigido da 100 W + 4 x Piedini di montaggio solari rigidi ',
        img: '/img/calculators/mm100/solar-detail-400-rigid.jpg',
        imgH5: '/img/calculators/mm100H5/solar-400-rigid.jpg',
        specParams: [{
          key: 'Potenza nominale',
          value: '400W (+/-3W)'
        }, {
          key: 'Tensione a circuito aperto',
          value: '37,10V'
        }, {
          key: 'Corrente di cortocircuito',
          value: '13,79A'
        }, {
          key: 'Tensione di esercizio massima',
          value: '31,00V'
        }, {
          key: 'Corrente di esercizio massima',
          value: '12,90A'
        }, {
          key: 'Coefficiente di temperatura della potenza nominale',
          value: '-0.38 % /°C'
        }, {
          key: 'Coefficiente di temperatura della tensione a circuito aperto',
          value: '-0.35 % /°C'
        }, {
          key: 'Coefficiente di temperatura della corrente di cortocircuito',
          value: '+0.06 % /°C'
        }, {
          key: 'Tensione massima del sistema',
          value: '1500V DC'
        }, {
          key: 'Corrente massima del fusibile',
          value: '25A'
        }, {
          key: 'Temperatura di esercizio',
          value: '-20°C - +50°C'
        }, {
          key: 'Peso del pannello solare',
          value: 'circa 21,8 kg'
        }, {
          key: 'Dimensioni',
          value: '1722 × 1134 × 35 mm'
        }]
      },
      question: {}
    }, {
      productId: '7795654951153',
      variantId: '43234258387185',
      name: '1 x Pannello solare flessibile da 100W',
      discountPrice: 129,
      originalPrice: 149,
      // discountRate: 0.8,
      unit: '€',
      number: 0,
      capacity: 100,
      img: '/img/calculators/mm100/solar-100-flexible.jpg',
      imgH5: '/img/calculators/mm100H5/solar-100-flexible.jpg',
      // desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      details: {
        title: '1 x Pannello solare flessibile da 100W',
        desc: '',
        img: '/img/calculators/mm100/solar-detail-100-flexible.jpg',
        imgH5: '/img/calculators/mm100H5/solar-100-flexible.jpg',
        specParams: [{
          key: 'Potenza nominale',
          value: '100W (+/-5W)'
        }, {
          key: 'Tensione a circuito aperto',
          value: '20,3V'
        }, {
          key: 'Corrente di cortocircuito',
          value: '6,3A'
        }, {
          key: 'Tensione di esercizio massima',
          value: '17,1V'
        }, {
          key: 'Corrente di esercizio massima',
          value: '5,9A'
        }, {
          key: 'Coefficiente di temperatura della potenza nominale',
          value: '-0,39%/°C'
        }, {
          key: 'Coefficiente di temperatura della tensione a circuito aperto',
          value: '-0,33%/°C'
        }, {
          key: 'Coefficiente di temperatura della corrente di cortocircuito',
          value: '0,06%/°C'
        }, {
          key: 'Tensione massima del sistema',
          value: '600 V CC (UL)'
        }, {
          key: 'Corrente massima del fusibile',
          value: '15A'
        }, {
          key: 'Peso del pannello solare',
          value: 'circa 2,3 kg (5,1 lb)'
        }, {
          key: 'Dimensioni',
          value: '1,055 x 612 x 25 mm (41.5 x 24,1 x 1,0 pollici)'
        }]
      },
      question: {}
    }
    // {
    //     productId: '6618094960713',
    //     variantId: '39998021697609',
    //     name: '1*400W Portable Solar Panel',
    //     discountPrice: 1199,
    //     originalPrice: 1199,
    //     // discountRate: 0.8,
    //     unit: '€',
    //     number: 0,
    //     capacity: 400,
    //     locale: ['us', 'ca', 'au', 'jp'], // only for us site
    //     img: '/img/calculators/mm100/solar-400-portable.jpg',
    //     imgH5: '/img/calculators/mm100H5/solar-400-portable.jpg',
    //     // desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
    //     details: {
    //         title: '1*400W Portable Solar Panel',
    //         desc: '',
    //         img: '/img/calculators/mm100/solar-detail-400-portable.jpg',
    //         imgH5: '/img/calculators/mm100H5/solar-400-portable.jpg',
    //         specParams: [
    //             { key: 'Potenza nominale', value: '400W(+/-10W)' },
    //             { key: 'Tensione a circuito aperto', value: '48V(Vmp 41V)' },
    //             { key: 'Corrente di cortocircuito', value: '11A(Imp 9.8A)' },
    //             { key: 'Efficiency', value: '22.4 %' },
    //             { key: 'Cell Type', value: 'Monocrystalline silicon' },
    //             { key: 'Connector type', value: 'MC4' },
    //             { key: 'Weight', value: '46.3 lbs(21.0KG)' },
    //             { key: 'Solar Panel', value: '33.1lbs(15.0KG)' },
    //             {
    //                 key: 'Unfolded Dimensioni',
    //                 value: '42.0 * 94.1 * 1.0 in (106.8 * 239.0 * 2.4cm)',
    //             },
    //             {
    //                 key: 'Folded Dimensioni',
    //                 value: '42.0 * 24.4 * 1.0 in (106.8 * 62.0 * 2.4cm)',
    //             },
    //         ],
    //     },
    //     question: {},
    // },
    ],

    // bundle imgs when choose the bundle (left main image)  - variant_id
    bundleImgs: {
      43104481247473: 'power-2kw.jpg',
      43104481280241: 'bundle-2kw-dp.jpg',
      43104481313009: 'bundle-2kw-all.jpg',
      43104482459889: 'power-4kw.jpg',
      43104482492657: 'bundle-4kw-dp.jpg',
      43104482525425: 'bundle-4kw-all.jpg',
      43104483508465: 'power-5kw.jpg',
      43104483541233: 'bundle-5kw-dp.jpg',
      43104483574001: 'bundle-5kw-all.jpg',
      43104483770609: 'power-10kw.jpg',
      43104483803377: 'bundle-10kw-dp.jpg',
      43104483836145: 'bundle-10kw-all.jpg',
      43104484098289: 'power-15kw.jpg',
      43104484131057: 'bundle-15kw-dp.jpg',
      43104484163825: 'bundle-15kw-all.jpg'
    },
    // solar price discount rate => 2022-06-22: not in use anymore
    // solarDiscountRate: {
    //     // product_id
    //     '6757458116681': {
    //         '0': 0.92,
    //         '1': 0.87,
    //         '2': 0.85,
    //     },
    //     '6757463720009': {
    //         '0': 0.87,
    //         '1': 0.84,
    //         '2': 0.82,
    //     },
    //     '6757464277065': {
    //         '0': 0.89,
    //         '1': 0.85,
    //         '2': 0.85,
    //     },
    //     '6757469388873': {
    //         '0': 0.87,
    //         '1': 0.85,
    //         '2': 0.8,
    //     },
    //     '6757470011465': {
    //         '0': 0.89,
    //         '1': 0.85,
    //         '2': 0.82,
    //     },
    // },

    // combo's original price under the bundle
    comboPrice: {
      // productId
      7763555057905: {
        original: [0, 570, 900],
        discount: [0, 500, 800]
      },
      7763555221745: {
        original: [0, 570, 900],
        discount: [0, 500, 800]
      },
      7763555385585: {
        original: [0, 570, 900],
        discount: [0, 500, 800]
      },
      7763555549425: {
        original: [0, 570, 900],
        discount: [0, 500, 800]
      },
      7763555713265: {
        original: [0, 570, 900],
        discount: [0, 500, 800]
      }
    },
    // common power kit's details
    powerDetails: {
      title: 'Power Hub EcoFlow',
      img: '/img/calculators/mm100/defaultDetail.jpg',
      desc: 'Il Power Hub è il cuore del tuo Power Kit e ti fa risparmiare spazio prezioso nel tuo camper o nella tua abitazione off-grid. Il Power Hub svolge il lavoro di due centraline di carica solare MPPT, un caricabatteria con MPPT, un convertitore CC-CC step-down e un inverter-caricatore, tutto in una singola unità, rendendo la configurazione più facile che mai.',
      specParams: [{
        key: 'Peso netto',
        value: '14 kg'
      }, {
        key: 'Dimensioni',
        value: '30 × 48 × 14 cm (Altezza × Larghezza × Profondità)'
      }, {
        key: 'Test e certificazione',
        value: 'CE, UL, FCC'
      }, {
        key: 'WI-FI',
        value: 'Supportato'
      }, {
        key: 'Bluetooth',
        value: 'Supportato'
      }, {
        key: 'Uscita/Frequenza principale CA',
        value: 'Onda sinusoidale pura, 3600W (sovratensione 6000W), 230V, 50Hz/60Hz'
      }, {
        key: 'Uscita principale CC',
        value: '13,6V/70A, 1000W Max; 26,4V/60A, 1500W Max'
      }, {
        key: 'Ingresso principale CA',
        value: ' Ricarica rapida X-Stream 3000W Max, 16A Max'
      }, {
        key: "Tensione/Frequenza d'ingresso principale CA",
        value: '220V-240V, 50Hz/60Hz'
      }, {
        key: 'Ingresso per ricarica solare',
        value: '15V-150V, 30A, 1600W Max'
      }, {
        key: "Ingresso di ricarica dell'alternatore:",
        value: '13V-60V, 60A, 1000W Max'
      }, {
        key: 'Temperatura di esercizio ottimale',
        value: '20 °C-30 °C'
      }, {
        key: 'Temperatura di scarica',
        value: '-25 °C-60 °C'
      }, {
        key: 'Temperatura di carica',
        value: '-25 °C-60 °C'
      }, {
        key: 'Temperatura di conservazione',
        value: '-25 °C-60 °C'
      }]
    },
    // common solar panel's questions
    solarQuestion: {
      text: "Il tempo di funzionamento aumentato è calcolato su una media dell'80% di ingresso da pannello solare e 5 ore di luce solare."
    },
    // // installations
    // installOptions: [
    //     {
    //         variantId: 0,
    //         i18n: 'self',
    //     },
    //     {
    //         productId: '8430069023069',
    //         variantId: '46942631166301',
    //         i18n: 'expert',
    //         i18n_des: 'pro',
    //     },
    // ],

    // tax price tag
    taxPriceTag: {
      jp: '(税込)'
    },
    isPriveReverseFlag: false,
    wire: {
      name: 'Pacchetto cavi + Staffa di montaggio'
    },
    installTerms: {
      title: 'Free Installation Terms and Conditions*',
      text: '1. Orders placed between 2022.08.25 to 2022.09.30 will be qualified for this limited-time offer. \n2. For addresses within the EcoFlow installer network, EcoFlow would contact you to make an appointment for free installation service. \n3. For addresses outside the EcoFlow installer network, customers can choose local installers. EcoFlow will reimburse the installation cost of Power Kits products.',
      sup: '*EcoFlow reserves the rights of final interpretation.'
    }
  };
};